import { AnswerBlockFragment, QuestionType } from "@/generated/graphql";

import { PageInfo } from "../answer-slice";

export function groupAnswerBlocksByQuestion(
  answerBlocks: AnswerBlockFragment[]
): {
  bodyBlock?: AnswerBlockFragment;
  referencesBlock?: AnswerBlockFragment;
}[] {
  const groups = answerBlocks.reduce<Record<string, AnswerBlockFragment[]>>(
    (acc, block) => {
      const key = block.question?.id ?? block.id;
      if (!acc[key]) acc[key] = [];
      acc[key].push(block);
      return acc;
    },
    {}
  );
  return Object.values(groups).map((blocks) => {
    const referencesBlock = blocks.find(
      (block) => block.blockName === "references"
    );
    const bodyBlock = blocks.find(
      (block) => !block.blockName || block.blockName === "body"
    );
    return { bodyBlock, referencesBlock };
  });
}

export function mapAnswerBlocksToPageInfo(
  answerBlocks: AnswerBlockFragment[]
): PageInfo[] {
  const groupedByQuestion = groupAnswerBlocksByQuestion(answerBlocks);

  return groupedByQuestion.flatMap(({ bodyBlock, referencesBlock }) => {
    if (!bodyBlock) {
      return [];
    }

    if (bodyBlock.question?.questionType === QuestionType.Overview) {
      return [];
    }

    let parentAnswerId: string | undefined = undefined;
    if (bodyBlock.parentNodeId) {
      parentAnswerId = answerBlocks.find(
        (ans) => ans.nodeId === bodyBlock.parentNodeId
      )?.id;
    }

    return [
      {
        page: "answer",
        answerId: bodyBlock.id,
        referencesAnswerId: referencesBlock?.id,
        questionType: bodyBlock.question?.questionType,
        parentAnswerId,
        confirm: !!bodyBlock.confirm,
      },
    ];
  });
}
